import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
export const OfficeFormContext = createContext();

export const OfficeFormProvider = ({ children }) => {
    const [officeFormData, setOfficeFormData] = useState({});

    return (
        <OfficeFormContext.Provider value={{ officeFormData, setOfficeFormData }}>
            {children}
        </OfficeFormContext.Provider>
    );
};

OfficeFormProvider.propTypes = {
    children: PropTypes.node.isRequired
};
